import { isEmpty } from 'lodash';
// @ts-ignore
import MESSAGES from 'constants/messages';
// @ts-ignore
import {
  stringMaxLengthIsInvalid,
  projectNameIsInvalid,
} from 'store/utils/validators';
import { FormData } from 'scenes/Projects/types';

const baseValidate = ({ name, account }: Partial<FormData>) => {
  const errors: FormData = {};

  if (!name) {
    errors.name = MESSAGES.PROJECTS.NAME.REQUIRED;
  }

  if (stringMaxLengthIsInvalid(name)) {
    errors.name = MESSAGES.PROJECTS.NAME.MAX_LENGTH;
  }

  if (name && projectNameIsInvalid(name)) {
    errors.name = MESSAGES.PROJECTS.NAME.REGEX;
  }

  if (!account) {
    errors.account = MESSAGES.PROJECTS.ACCOUNT;
  }

  return errors;
};

export const importProjectValidate = ({
  name,
  account,
  files,
}: Partial<FormData>) => {
  const errors = baseValidate({
    name,
    account,
  });

  if (!files || isEmpty(files)) {
    errors.files = MESSAGES.PROJECTS.FILE;
  } else if (files && files.length > 1) {
    errors.files = MESSAGES.PROJECTS.ALLOWED_NUMBER_OF_FILES;
  }

  return errors;
};

export const cloneProjectValidate = ({
  name,
  account,
  project,
}: Partial<FormData>) => {
  const errors = baseValidate({
    name,
    account,
  });

  if (!project || !project.id) {
    errors.project = MESSAGES.PROJECTS.CLONED_PROJECT;
  }

  return errors;
};

export const newProjectValidate = ({ name, account }: Partial<FormData>) =>
  baseValidate({ name, account });
